const duration = 260
const options = { duration, easing: 'ease-in-out' }

// Keep departing cards visible only for the animation; React owns the live links.
export default function animateScheduleChange (grid, update) {
  if (!grid?.animate) {
    update()
    return () => {}
  }

  const before = grid.getBoundingClientRect()
  const previous = new Map(Array.from(grid.children, card => [card.dataset.scheduleKey, {
    rect: card.getBoundingClientRect(),
    copy: card.cloneNode(true)
  }]))
  const animations = []
  const departing = []
  const cleanup = () => {
    animations.forEach(animation => animation.cancel())
    departing.forEach(card => card.remove())
  }

  update()

  const after = grid.getBoundingClientRect()
  Array.from(grid.children).forEach(card => {
    const old = previous.get(card.dataset.scheduleKey)
    const rect = card.getBoundingClientRect()
    animations.push(card.animate(old ? [
      { transform: `translate(${old.rect.left - rect.left}px, ${old.rect.top - rect.top}px)` },
      { transform: 'translate(0, 0)' }
    ] : [
      { opacity: 0, transform: 'translateY(10px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], options))
    previous.delete(card.dataset.scheduleKey)
  })

  previous.forEach(({ copy, rect }) => {
    copy.setAttribute('aria-hidden', 'true')
    copy.setAttribute('inert', '')
    copy.tabIndex = -1
    Object.assign(copy.style, {
      position: 'absolute',
      pointerEvents: 'none',
      margin: '0',
      left: `${rect.left - before.left}px`,
      top: `${rect.top - before.top}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`
    })
    grid.appendChild(copy)
    departing.push(copy)
    animations.push(copy.animate([
      { opacity: 1, transform: 'translateY(0)' },
      { opacity: 0, transform: 'translateY(-10px)' }
    ], { ...options, fill: 'forwards' }))
  })

  animations.push(grid.animate([
    { height: `${before.height}px`, overflow: 'clip' },
    { height: `${after.height}px`, overflow: 'clip' }
  ], options))
  Promise.all(animations.map(animation => animation.finished)).then(cleanup, cleanup)
  return cleanup
}
